<template>
  <div class="scene signup flex-r">
    <div class="section size-50" />

    <div id="step-container" class="size-40">
      <div class="signup-form-bg shadow-large">
        <h1 style="margin-bottom:60px;">
          Заполните информацию о компании
        </h1>

        <base-input
          v-model.trim="$v.signUpCredentials.project.name.$model"
          :is-have-error="$v.signUpCredentials.project.name.$error"
          label="Наименование компании"
          placeholder='ООО "Джаст Резерв"'
        >
          <div
            v-if="$v.signUpCredentials.project.name.$error && !$v.signUpCredentials.project.name.required"
            class="f-input-text"
          >
            Наименование компании обязательно.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.legalAddress.$model"
          :is-have-error="$v.signUpCredentials.project.legalAddress.$error"
          label="Юридический адрес"
          placeholder="г. Минск, улица Шаранговича 67. офис 303"
        >
          <div
            v-if="$v.signUpCredentials.project.legalAddress.$error && !$v.signUpCredentials.project.legalAddress.required"
            class="f-input-text"
          >
            Юридический адрес обязателен.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.addressForCorrespondence.$model"
          :is-have-error="$v.signUpCredentials.project.addressForCorrespondence.$error"
          label="Адрес для корреспонденции"
          placeholder="г. Минск, улица Шаранговича 67. офис 303"
        >
          <div
            v-if="$v.signUpCredentials.project.addressForCorrespondence.$error && !$v.signUpCredentials.project.addressForCorrespondence.required"
            class="f-input-text"
          >
            Адрес для корреспонденции обязателен.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.tin.$model"
          :is-have-error="$v.signUpCredentials.project.tin.$error"
          label="УНП"
          placeholder="192954057"
        >
          <div
            v-if="$v.signUpCredentials.project.tin.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.tin.required">
              УНП обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.tin.numeric">
              УНП должен состоять только из чисел
            </template>

            <template v-else-if="!$v.signUpCredentials.project.tin.minLength">
              УНП не может быть короче {{ $v.signUpCredentials.project.tin.$params.minLength.min }} символов
            </template>

            <template v-else-if="!$v.signUpCredentials.project.tin.maxLength">
              УНП не может быть длинее {{ $v.signUpCredentials.project.tin.$params.maxLength.max }} символов
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.checkingAccountIBAN.$model"
          :is-have-error="$v.signUpCredentials.project.checkingAccountIBAN.$error"
          label="Расчётный счёт IBAN"
          placeholder="BY11 ALFA 3012 2259 6801 6027 0000"
        >
          <div
            v-if="$v.signUpCredentials.project.checkingAccountIBAN.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.checkingAccountIBAN.checkingAccountIBAN">
              Невалидный расчётный счёт IBAN
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.bankBicCode.$model"
          :is-have-error="$v.signUpCredentials.project.bankBicCode.$error"
          label="Код банка BIC"
          placeholder="ALFABY2X"
        >
          <div
            v-if="$v.signUpCredentials.project.bankBicCode.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.bankBicCode.required">
              Код банка BIC обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.bankBicCode.bicCode">
              Невалидный код банка BIC
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.bankName.$model"
          :is-have-error="$v.signUpCredentials.project.bankName.$error"
          label="Банк"
          placeholder='"ЗАО "Альфа-Банк"'
        >
          <div
            v-if="$v.signUpCredentials.project.bankName.$error && !$v.signUpCredentials.project.bankName.required"
            class="f-input-text"
          >
            Название банка обязательно.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.bankAddress.$model"
          :is-have-error="$v.signUpCredentials.project.bankAddress.$error"
          label="Адрес банка"
          placeholder="г. Минск, ул. Притыцкого, 97"
        >
          <div
            v-if="$v.signUpCredentials.project.bankAddress.$error && !$v.signUpCredentials.project.bankAddress.required"
            class="f-input-text"
          >
            Адрес банка обязателен.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.phone.$model"
          :is-have-error="$v.signUpCredentials.project.phone.$error"
          label="Телефон организации"
          placeholder="+375 XX XXX-XX-XX"
        >
          <div
            v-if="$v.signUpCredentials.project.phone.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.phone.required">
              Телефон обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.phone.phone">
              Невалидный телефон
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.email.$model"
          :is-have-error="$v.signUpCredentials.project.email.$error"
          label="E-mail организации для обмена документами и связи"
          placeholder="sales@justreserve.me"
        >
          <div
            v-if="$v.signUpCredentials.project.email.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.email.required">
              E-mail обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.email.email">
              Невалидный email
            </template>
          </div>
        </base-input>

        <h2 style="margin-top:100px;">
          Лицо, заключающее договор
        </h2>

        <p>
          На основе этих данных будут созданы документы и учетная запись для управления инфраструктурой и правами
          доступа.
        </p>

        <base-input
          v-model.trim="$v.signUpCredentials.project.firstName.$model"
          :is-have-error="$v.signUpCredentials.project.firstName.$error"
          label="Имя"
          placeholder="Артём"
        >
          <div
            v-if="$v.signUpCredentials.project.firstName.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.firstName.required">
              Имя обязателено.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.firstName.name">
              Введите существующее имя
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.lastName.$model"
          :is-have-error="$v.signUpCredentials.project.lastName.$error"
          label="Фамилия"
          placeholder="Наумов"
        >
          <div
            v-if="$v.signUpCredentials.project.lastName.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.lastName.required">
              Фамилия обязателена.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.lastName.name">
              Введите существующую фамилию
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.thirdName.$model"
          :is-have-error="$v.signUpCredentials.project.thirdName.$error"
          label="Отчество"
          placeholder="Дмитриевич"
        >
          <div
            v-if="$v.signUpCredentials.project.thirdName.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.thirdName.required">
              Отчество обязателено.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.thirdName.name">
              Введите существующее отчество
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.position.$model"
          :is-have-error="$v.signUpCredentials.project.position.$error"
          label="Должность"
          placeholder="Директор"
        >
          <div
            v-if="$v.signUpCredentials.project.position.$error && !$v.signUpCredentials.project.position.required"
            class="f-input-text"
          >
            Должность обязателена.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.staff.phone.$model"
          :is-have-error="$v.signUpCredentials.staff.phone.$error"
          label="Телефон"
          placeholder="+375 XX XXX-XX-XX"
        >
          <div
            v-if="$v.signUpCredentials.staff.phone.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.staff.phone.required">
              Телефон обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.staff.phone.phone">
              Невалидный телефон
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.staff.email.$model"
          :is-have-error="$v.signUpCredentials.staff.email.$error"
          label="E-mail"
          placeholder="info@justreserve.me"
        >
          <div
            v-if="$v.signUpCredentials.staff.email.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.staff.email.required">
              E-mail обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.staff.email.email">
              Невалидный email
            </template>
          </div>
        </base-input>

        <label class="f-input">
          <select
            v-model="signUpCredentials.project.documentTypes"
            name="document-type"
            multiple
          >
            <option value="1" selected>
              Устав
            </option>

            <option value="2">
              Приказ о назначении на должность
            </option>

            <option value="3">
              Трудовой договор
            </option>

            <option value="4">
              Договор на управление
            </option>

            <option value="5">
              Протокол / Решение
            </option>

            <option value="6">
              Доверенность
            </option>

            <option value="7">
              Учередительный договор
            </option>

            <option value="7">
              Паспорт
            </option>
          </select>

          <div class="f-input-name">
            Выберите тип документа
          </div>
        </label>

        <vue-dropzone
          ref="dropzone"
          id="dropzone"
          :options="dropzoneOptions"
          :useCustomSlot="true"
          class="f-input"
          :class="{ error: $v.signUpCredentials.documents.$error }"
          @vdropzone-success="handleDropzoneFileSuccessUploaded"
          @vdropzone-removed-file="handleDropzoneFileWasRemoved"
        >
          <div class="dz-message-image">
            <img src="/img/svg/docs-placeholder.svg">
          </div>
          <div class="dz-message-header">
            Перетащите сюда документ, или воспользуйтесь
            <br>
            файловым менеджером
          </div>

          <div class="dz-message-desc">
            Поддерживаемые форматы: PDF, JPG, PNG, BMP.
          </div>

          <button class="button primary">
            <span class="text">Загрузить документ</span>

          </button>

          <div
            v-if="$v.signUpCredentials.documents.$error && !$v.signUpCredentials.documents.required"
            class="f-input-text"
          >
            Документ, подтверждающий личность, обязателен
          </div>
        </vue-dropzone>

        <h2 style="margin-top:100px;">
          Информация о заведении для клиентов
        </h2>

        <p>
          Информация, которая отображается во встраиваемом виджете и онлайн-службах.
        </p>

        <base-input
          v-model.trim="$v.signUpCredentials.place.name.$model"
          :is-have-error="$v.signUpCredentials.place.name.$error"
          label="Название заведения"
          placeholder="Just Reserve Me"
        >
          <div
            v-if="$v.signUpCredentials.place.name.$error && !$v.signUpCredentials.place.name.required"
            class="f-input-text"
          >
            Навание заведения обязателено.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.place.address.$model"
          :is-have-error="$v.signUpCredentials.place.address.$error"
          label="Адрес заведения"
          placeholder="улица Шаранговича 67"
        >
          <div
            v-if="$v.signUpCredentials.place.address.$error && !$v.signUpCredentials.place.address.required"
            class="f-input-text"
          >
            Адрес заведения обязателен.
          </div>
        </base-input>

        <div class="signup-form-buttons flex-r">
          <div class="section size-50">
            <div
              class="button"
              @click="emitBackEvent"
            >
              <div class="text">
                Назад
              </div>
            </div>
          </div>

          <div class="section size-50 txt-algn-r">
            <div
              class="button primary"
              :class="{ disabled: $v.$invalid }"
              @click="setFilledProjectAndContractorInformation"
            >
              <div class="text">
                Следующий шаг
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isOnboardingShow"
          style="position: absolute; height: 100%; width: 100%; top: 0; left: 0; background-color: rgba(255,255,255,.97); padding: 80px 30px; border-radius: 50px;"
        >
          <div class="flex-c">
            <div class="section size-10"></div>
            <div class="section size-80">
              <h1>
                В данный момент онлайн-регистрация находится в режиме тестирования, но вы можете
                приехать к нам в офис для заключения договора в любой рабочий день.
                <br>
                <br>
                Все вопросы по телефону <span class="nowrap">+375 25 956-75-54</span>.
              </h1>

              <div class="button" @click="closeOnboarding">
                CLOSE
              </div>
            </div>
            <div class="section size-10"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
// Todo: rewrite this shit component
import vueDropzone from 'vue2-dropzone';
import { required } from 'vuelidate/lib/validators';
import { AsYouType } from 'libphonenumber-js';
import projectValidationModel from '@/validators/model/project';
import staffValidationModel from '@/validators/model/staff';
import placeValidationModel from '@/validators/model/place';
import cloneDeep from 'lodash.clonedeep';
import IBAN from 'fast-iban';

export default {
  name: 'FillLegalProjectInformationStep',
  validations: {
    signUpCredentials: {
      project: projectValidationModel,
      staff: staffValidationModel,
      place: placeValidationModel,
      documents: {
        required
      }
    }
  },
  components: {
    vueDropzone
  },
  props: {
    initSignUpCredentials: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      signUpCredentials: cloneDeep(this.initSignUpCredentials),
      dropzoneOptions: {
        url: this.$generateAbsolutePath('/file/upload'),
        thumbnailWidth: 150,
        addRemoveLinks: true,
        acceptedFiles: 'image/*,application/pdf,.doc,.docx'
      },
      isOnboardingShow: true
    }
  },
  watch: {
    'signUpCredentials.project.checkingAccountIBAN'(checkingAccountIBAN) {
      if (checkingAccountIBAN) {
        const formattedIBAN = IBAN.formatIBAN(checkingAccountIBAN);

        if (formattedIBAN !== checkingAccountIBAN) {
          this.signUpCredentials.project.checkingAccountIBAN = formattedIBAN;
        }
      }
    },
    'signUpCredentials.project.phone'(phone) {
      const formattedPhone = new AsYouType().input(phone);

      if (formattedPhone !== phone) {
        this.signUpCredentials.project.phone = formattedPhone;
      }
    },
    'signUpCredentials.staff.phone'(phone) {
      const formattedPhone = new AsYouType().input(phone);

      if (formattedPhone !== phone) {
        this.signUpCredentials.staff.phone = formattedPhone;
      }
    }
  },
  mounted() {
    for (let index = 0; index < this.signUpCredentials.documents.length; index++) {
      const image = this.signUpCredentials.documents[index];

      this.$refs.dropzone.manuallyAddFile(
        image.file,
        this.$generateAbsolutePath(image.path)
      );
    }
  },
  methods: {
    handleDropzoneFileSuccessUploaded(file, response) {
      this.signUpCredentials.documents.push({
        ...response,
        file
      });
    },
    handleDropzoneFileWasRemoved(removedFile) {
      const imageIndex = this.signUpCredentials.documents.findIndex(({ file }) => file === removedFile);

      if (imageIndex !== -1) {
        this.signUpCredentials.documents.splice(imageIndex, 1);
      }
    },
    setFilledProjectAndContractorInformation() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('next', cloneDeep(this.signUpCredentials));
      }
    },
    emitBackEvent() {
      this.$emit('back', cloneDeep(this.signUpCredentials));
    },
    closeOnboarding() {
      if (window.confirm('Вы точно хотите продолжить?')) {
        this.isOnboardingShow = false;
      }
    }
  }
}
</script>

<style>
  @import "~vue2-dropzone/dist/vue2Dropzone.min.css";
</style>
